import * as types from '../types/facility';

const initialState = {
  fetching: false,

  ownership_type: [],
  facility_category: [],
  facility_type: [],
  facility_care_class: [],
  facility_service_type: [],
  facility_service: [],

  // care_class: [],
  // clinic_type: [],
  // allied_other_facility_type: [],
  // care_class: [],
  // inpatient_service: [],
  // outpatient_service: [],
  // support_service: [],
  // pharmacy_services: [],
  // facility_type: [],
  // hospital_type: [],
  // medical_center_type: [],
  // pharmacy_type: [],
  // ownership_type:[],
  // application_status:[],

  facilityLookupsError: null
}

export default function facilityLookups(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_FACILITY_LOOKUPS_REQ:
      return {
        ...initialState, fetching: true
      };
    case types.FETCH_FACILITY_LOOKUPS_RES:
      return {
        ...initialState,
        ownership_type: action.data.ownership_type,
        facility_category: action.data.facility_category,
        facility_type: action.data.facility_type,
        facility_care_class: action.data.facility_care_class,
        facility_service_type: action.data.facility_service_type,
        facility_service: action.data.facility_service      
      };
    case types.FETCH_FACILITY_LOOKUPS_ERR:
      return {
        ...state,
        fetching: false,
        facilityLookupsError: action.data
      };
    default:
      return state;
  }
}